import { PermissionT } from "../types";

export const betaUser = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "beta_user");
  return !!p;
};

export default betaUser;
